<template>
  <div class="d-flex pb-3">
    <div class="page-title-header flex-fill">
      <slot>{{ title }}</slot>
    </div>
    <div>
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    title: String,
  },
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
.page-title-header {
  font-size: 1.5rem;
  font-weight: 500;
}
</style>
